<template>
    <div class="d-flex flex-column list">
        <template v-for="(f, index) of localFields">
            <key-value-cell :key="index" :value="getValue(f)" :custom-value="f.type === 'image'">
                {{ f.label }}
                <template #value>
                    <template v-if="item[f.key]">
                        <b-img v-for="id of item[f.key].split(',')" :key="id" :src="_generateDownloadUrl(id)"
                               fluid class="mb-1 mr-1"
                               style="max-height: 250px"
                               @click="viewImg(id, item[f.key].split(','))">
                        </b-img>
                    </template>
                    <span :key="index" v-else>
                        未上传
                    </span>
                </template>
            </key-value-cell>
        </template>

        <re-b-modal ref="viewImg" clean centered fit-content no-max-width>
            <b-img fluid fluid-grow :src="_generateDownloadUrl(currentImages[currentImg])" @click="cancelView"></b-img>

            <a href="#" role="button"
               class="carousel-control-prev"
               @click="switchImg(false)">
                <span aria-hidden="true" class="carousel-control-prev-icon"></span>
                <span class="sr-only">Previous slide</span>
            </a>
            <a href="#" role="button"
               class="carousel-control-next"
               @click="switchImg()">
                <span aria-hidden="true" class="carousel-control-next-icon"></span>
                <span class="sr-only">Next slide</span>
            </a>
        </re-b-modal>
    </div>
</template>

<script>
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import formMixin from "@/components/common/inputs/mixin/form-mixin";
import KeyValueCell from "@/views/sithMes/prd/PrdOperationExcute/cells/KeyValueCell.vue";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";

export default {
    name: "FormView",
    components: {ReBModal, KeyValueCell},
    mixins: [emCommonUtilMixin, formMixin],
    props: {
        item: Object,
    },
    data() {
        return {
            currentImg: null,
            currentImages: [],
        }
    },
    methods: {
        getValue(field) {
            let result = this.item[field.key];
            if (field.optionsFromDict) {
                return this._translateDict(field.optionsFromDict, result);
            }
            if (this.$store.state.dictionaryEnumStore.reloadFlag) {
                //
            }
            if (field.options) {
                for (let o of field.options) {
                    if (o.value === result) {
                        return o.label;
                    }
                }
            }
            return result;
        },

        viewImg(id, list) {
            let index = list.indexOf(id);
            if (index >= 0) {
                this.currentImg = index;
                this.currentImages = list;
                this.$refs.viewImg.showModal();
            }
        },
        cancelView() {
            this.currentImg = null;
            this.$refs.viewImg.hide();
        },
        switchImg(next = true) {
            if (next) {
                if (this.currentImg === this.currentImages.length - 1) {
                    this.currentImg = 0;
                } else {
                    this.currentImg++;
                }
            } else {
                if (this.currentImg === 0) {
                    this.currentImg = this.currentImages.length - 1;
                } else {
                    this.currentImg--;
                }
            }
        },
    }
}
</script>

<style scoped>
.list {

}

.list div {
    padding: .3rem .5rem;
}
</style>
